import $ from 'shared/$';
import { isLessThan } from 'shared/mq';
import anime from 'animejs';

export default class Search {
  constructor(toggler) {
    this.isOpen = false;
    this.toggler = toggler; //document.querySelector('[href$="#search"]');

    const nav = $.parents(this.toggler, 'u-nav-quicklinks');

    if (!nav) {
      return;
    }

    this.content = nav.parentNode.querySelector('.u-search');

    // this.content = document.querySelector('.u-search');
    this.closeBtn = document.querySelector('.u-search__close__btn');

    if (!this.toggler || !this.content) {
      console.error('no search elements found');
      return;
    }

    this.isSearchFormOpen = false;
    this.container = this.content.querySelector('.u-search__container');
    this.localSearchForm = this.content.querySelector('.u-search__bottom');
    this.localSearchToggle = this.content.querySelector('[data-local-search]');

    this.bind();
  }

  bind() {
    this.onToggle = this.onToggle.bind(this);
    this.close = this.close.bind(this);
    this.onClickOutside = this.onClickOutside.bind(this);
    this.toggler.addEventListener('click', this.onToggle);
    this.localSearchToggle.addEventListener('click', this.showSearchForm.bind(this));

    document.body.addEventListener('click', this.onClickOutside);
    document.body.addEventListener('touchend', this.onClickOutside);

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close);
    }
  }

  showSearchForm(e) {
    e.preventDefault();

    if (isLessThan('medium')) {
      this.appendForm();
    } else {
      this.toggleForm();
    }
  }

  appendForm() {
    if (!this.isSearchFormOpen) {
      this.isSearchFormOpen = true;
      this.localSearchToggle.classList.add('active');

      $.insertAfter(this.localSearchToggle, this.localSearchForm.querySelector('form'));
    } else {
      this.isSearchFormOpen = false;
      this.localSearchToggle.classList.remove('active');

      this.localSearchForm
        .querySelector('.u-wrapper')
        .appendChild(this.container.querySelector('.u-search__options form'));
    }
  }

  toggleForm() {
    if (!this.isSearchFormOpen) {
      this.localSearchToggle.classList.add('active');

      anime({
        targets: this.localSearchForm,
        translateY: ['-100%', '0%'],
        easing: 'easeOutQuad',
        duration: 550,
        complete: () => {
          this.isSearchFormOpen = true;
        },
      });
    } else {
      this.localSearchToggle.classList.remove('active');

      anime({
        targets: this.localSearchForm,
        translateY: ['0%', '-100%'],
        easing: 'easeOutQuad',
        duration: 550,
        complete: () => {
          this.isSearchFormOpen = false;
          document.body.classList.remove('menu-open');
        },
      });
    }
  }

  onClickOutside(e) {
    if (!this.isOpen) {
      return;
    }

    let el = e.target;
    let isRoot = el => {
      return el && el === this.content;
    };

    while (el && !isRoot(el)) {
      el = el.parentNode;
    }

    if (!isRoot(el)) {
      this.close();
    }
  }

  onToggle(e) {
    e.preventDefault();
    this.toggle();
  }

  toggle() {
    this[this.isOpen ? 'close' : 'open']();
  }

  open() {
    if (!isLessThan('nav')) {
      document.body.classList.add('menu-open');
    }

    anime({
      targets: this.container,
      translateY: ['-100%', '0%'],
      easing: 'easeOutQuad',
      duration: 550,
      complete: () => {
        this.isOpen = true;
      },
    });

    this.content.style.display = 'block';
    this.toggler.classList.add('active');

    // window.setTimeout(() => {
    //   this.isOpen = true;
    // }, 200);
  }

  close(e) {
    e && e.preventDefault();

    anime({
      targets: this.container,
      translateY: ['0%', '-100%'],
      easing: 'easeOutQuad',
      duration: 550,
      complete: () => {
        this.isOpen = false;
        this.content.style.display = 'none';
        this.toggler.classList.remove('active');
        if (!isLessThan('nav')) {
          document.body.classList.remove('menu-open');
        }
      },
    });

    // document.documentElement.classList.remove('u-search-open');
  }
}
